import { render } from "./RecentlyAdded.vue?vue&type=template&id=653293e0&scoped=true"
import script from "./RecentlyAdded.vue?vue&type=script&lang=js"
export * from "./RecentlyAdded.vue?vue&type=script&lang=js"

import "./RecentlyAdded.vue?vue&type=style&index=0&id=653293e0&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653293e0"]])

export default __exports__